import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

import type { ApprovalActionConfirmationModalVariant } from '../src/Modals/ApprovalActionConfirmationModal.tsx';

export const ApprovalActionConfirmationModal: LoadableType<{
	variant: ApprovalActionConfirmationModalVariant;
	onConfirm: () => void | Promise<void>;
	onClose: () => void;
}> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ApprovalActionConfirmationModal" */ '../src/Modals/ApprovalActionConfirmationModal.tsx'
			)
		).ApprovalActionConfirmationModal,
});
